import "./DataCoverage.scss";
import Tooltip from "components/atoms/Tooltip";
import { DataCoverageIcon } from "./DataCoverageIcon";
import DataCoverageTooltip from "./DataCoverageTooltip";

interface DataCoverageProps {
    dataCoverage: DataCoverage | DataCoverageEnum;
}

function DataCoverage({ dataCoverage }: DataCoverageProps) {
    const showTooltip = typeof dataCoverage === "object";
    const identifier = showTooltip ? dataCoverage.dataCoverage : dataCoverage;

    if (showTooltip)
        return (
            <Tooltip tooltipBody={<DataCoverageTooltip identifier={identifier} dataCoverage={dataCoverage} />}>
                <DataCoverageIcon identifier={identifier} />
            </Tooltip>
        );
    return <DataCoverageIcon identifier={identifier} />;
}

export default DataCoverage;
